import { CircularProgress, LinearProgress, Typography } from '@mui/material';
import Grid2 from '@thirdparty-framework/mui/material/Grid';

function FormLoading({ children = null, circular = false, ...props }) {
  return (
    <Grid2 container justifyContent="center" alignItems="center" {...props}>
      <Grid2 sx={{ margin: 0 }} xs={10} xsOffset={1} textAlign="center">
        {children && (
          <Typography variant="h6" component="div" sx={{ mb: 2 }}>
            {children}
          </Typography>
        )}
        {!circular && <LinearProgress />}
        {circular && <CircularProgress />}
      </Grid2>
    </Grid2>
  );
}

export default FormLoading;
